import React from "react"
import {AllowedUsersColumns} from "./Users.types"
import {User} from "../../resources/user"
import {Resource} from "../../resources/common"
import {Meta} from "../../resources/common"
import {DataTable, DataTableHead, DataTableBody, DataTableCell, DataTableRow} from "../DataTable/DataTable"
import PagingNavBar from "../PagingNavBar/PagingNavBar"
import UserRow from "./UserRow"

interface UsersTableProps {
	users: User[]
	hasResults: boolean
	hasPrev: boolean
	hasNext: boolean
	prev: () => void
	next: () => void
	isUsingPaging: boolean
	include?: Resource[]
	includedColumns: AllowedUsersColumns[]
	meta?: Meta
	refresh: () => void
	fullHeight?: boolean
	refreshToken?: number
}

export default function UsersTable({
	users,
	fullHeight,
	includedColumns,
	hasNext,
	hasPrev,
	hasResults,
	isUsingPaging,
	include,
	refresh,
	meta,
	prev,
	next,
}: UsersTableProps) {
	const noContent = users.length === 0
	return (
		<div className={"users-table"}>
			<DataTable isEmpty={noContent} fullHeight={fullHeight} stickyAction={fullHeight} noContentText={"No users found"}>
				<DataTableHead>
					<DataTableRow>
						{Object.entries(includedColumns).map((column) => {
							return <DataTableCell key={column[0]}>{column[1]}</DataTableCell>
						})}
					</DataTableRow>
				</DataTableHead>
				<DataTableBody>
					{users.map((u) => (
						<UserRow key={u.id} user={u} includedColumns={includedColumns} include={include} refresh={refresh} />
					))}
				</DataTableBody>
			</DataTable>
			<PagingNavBar
				hasResults={hasResults}
				hasPrev={hasPrev}
				hasNext={hasNext}
				prev={prev}
				next={next}
				isShow={isUsingPaging}
				meta={meta}
			/>
		</div>
	)
}
